import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ts-auto-mock/ts-auto-mock/ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "create-mock"
    }}>{`Create mock`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { createMock } from 'ts-auto-mock';

interface Person {
  id: string;
  getName(): string;
  details: {
      phone: number
  }
}
const mock = createMock<Person>();
mock.id // ""
mock.getName() // ""
mock.details // { phone: 0 }
`}</code></pre>
    <h2 {...{
      "id": "property-overrides"
    }}>{`Property overrides`}</h2>
    <p>{`If you desire, you may override the otherwise mocked properties of an interface.`}</p>
    <p>{`You don't have to provide the entire interface, just a partial object of the one you are mocking.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { createMock } from 'ts-auto-mock';

interface Person {
  id: string;
  getName(): string;
  details: {
    phone: number
  }
}

const mock = createMock<Person>({
    details: {
      phone: 7423232323
    }
});

mock.id // ""
mock.getName() // ""
mock.details // { phone: 7423232323 }
`}</code></pre>
    <h3 {...{
      "id": "override-with-created-mock-as-value"
    }}>{`Override with created mock as value`}</h3>
    <p>{`If a mock is used as a value in the override object the mock will be entirely assigned and not merged. This is done to
avoid issues with recursive mocks. Surely this won't be a problem for anyone but it's worth writing it in the documentation.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { createMock } from 'ts-auto-mock';

interface Person {
  id: string;
}

interface PersonParent {
  child: Person;
}

const personMock = createMock<Person>();
const parentMock = createMock<PersonParent>({
    child: personMock
});

parentMock.child === personMock // true

const personMock2 = createMock<Person>();
delete personMock2.id;
const parentMock2 = createMock<PersonParent>({
    child: personMock2
});

parentMock2.child === personMock2 // true
parentMock2.child.id // undefined, even if \`id\` was not in the override object (personMock2) it still did override
                     // because the entire \`personMock2\` was assigned to \`child\`
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      